<div class="atrizult-root-wrapper">
  <app-header *ngIf="showLayout"></app-header>

  <!-- The routed views render in the <router-outlet>-->
  <router-outlet></router-outlet>

  <app-footer *ngIf="showLayout"></app-footer>

</div>
